import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import CustomDateRangePicker from './dragDatePicker';
import CommonButton from '../button';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "3px"
  },
  container: ({
    overflow: 'hidden',
    transition: 'max-height 0.4s ease',
    maxHeight: 0,
    opacity: 0,
    transform: 'translateY(-10px)',
    transitionProperty: 'max-height, opacity, transform',
  }),
  absoluteCalendar: {
    position: 'absolute',
    zIndex: 1000,
  },
  containerVisible: {
    maxHeight: '500px', // Adjust based on expected content
    opacity: 1,
    transform: 'translateY(0)',
  },
  previewBox: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginTop: '8px',
    width: "max-content"
  }
}));

export default function DragDatePreviewer({
  startDateValue,
  setStartDateValue,
  endDateValue,
  setEndDateValue,
  showOnTop = false,
  absoluteCalendar = true
}) {
  const [visible, setVisible] = useState(false);

  const classes = useStyles({ absoluteCalendar });

  const togglePreview = () => setVisible(!visible);

  React.useEffect(() => {
    const [start, end] = [new Date(startDateValue), new Date(endDateValue)]
    if (visible && startDateValue && endDateValue && (start < end)) {
      setTimeout(() => setVisible(false), 300);
    }
  }, [startDateValue, endDateValue])

  return (
    <div className={classes.root}>
      {showOnTop ? (
        <div className={`${classes.container} ${absoluteCalendar ? classes.absoluteCalendar : ''} ${visible ? classes.containerVisible : ''}`}>
          <div className={classes.previewBox}>
            <CustomDateRangePicker
              startDateValue={startDateValue}
              setStartDateValue={setStartDateValue}
              setEndDateValue={setEndDateValue}
              endDateValue={endDateValue}
            />
          </div>
        </div>
      ) : null}
      <CommonButton
        text={
          `From ${moment(startDateValue).format('MMM D, YYYY')} to ${moment(endDateValue).format('MMM D, YYYY')}`
        }
        onClick={togglePreview}
        variant="contained"
        stylevariant="primary"
      />
      {!showOnTop ? (
        <div className={`${classes.container} ${absoluteCalendar ? classes.absoluteCalendar : ''} ${visible ? classes.containerVisible : ''}`}>
          <div className={classes.previewBox}>
            <CustomDateRangePicker
              startDateValue={startDateValue}
              setStartDateValue={setStartDateValue}
              setEndDateValue={setEndDateValue}
              endDateValue={endDateValue}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
